module.exports = __webpack_public_path__ + "img/DAY1-2.c3110f07.jpg";